import { errors } from 'redux-rest-reducer';

import { ACTIONS as logoutActions } from '@~/actions/logout';
import { ACTIONS } from '@~/actions/teacher-control';

export default function defaultExport(state = {}, { type, payload = {} }) {
  switch (type) {
    case ACTIONS.SET_TEACHER_CONTROL: {
      return payload;
    }
    case ACTIONS.UNSET_TEACHER_CONTROL: {
      return {};
    }
    case ACTIONS.SET_WTC_SHEET_PATCH_ID: {
      const { sheetPatchId } = payload || {};

      return {
        ...state,
        sheetPatchId,
      };
    }
    case ACTIONS.UNSET_WTC_SHEET_PATCH_ID: {
      const newState = { ...state };

      if (newState.sheetPatchId) delete newState.sheetPatchId;

      return newState;
    }
    case logoutActions.POST_SUCCESS: {
      return {};
    }
    case errors[401]: {
      return {};
    }
    default:
      return state;
  }
}
